export const PAGINATION_CURRENT_PAGE = 0;
export const PAGINATION_START = 0;
export const PAGINATION_LIMIT = 50;

export const COLUMNS = [
  {
    field: "category",
    header: "Catégorie",
    resizeable: true,
    alignHeader: 'center',
    align: 'left',
    style: {
      width: "270px"
    },
  },
  {
    field: "total",
    header: "Valeur actuelle",
    alignHeader: 'center',
  },
  {
    field: "previousYearCA",
    header: "N-1 (€ / clients)",
    alignHeader: 'center',
  },
  {
    field: "currentYearCA",
    header: "N (€ / clients)",
    alignHeader: 'center',
  },
  {
    field: "nextYearCA",
    header: "N+1 Prévision",
    alignHeader: 'center',
  },
  {
    field: "comment",
    header: "Commentaire / Note",
    alignHeader: 'center',
    align: 'center',
    style: {
      width: '400px'
    }
  },
];
